import { render, staticRenderFns } from "./StudyResultResolveList.vue?vue&type=template&id=5fe385ca&scoped=true&lang=pug"
import script from "./StudyResultResolveList.vue?vue&type=script&lang=ts"
export * from "./StudyResultResolveList.vue?vue&type=script&lang=ts"
import style0 from "./StudyResultResolveList.vue?vue&type=style&index=0&id=5fe385ca&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe385ca",
  null
  
)

export default component.exports